<section class="services">
  <div class="services__container">
    <h2 class="services__title">{{ "Services" | translate }}</h2>

    <div class="services__grid">
      <button
        *ngFor="let service of services"
        type="button"
        class="service-card"
        (click)="open(service)"
      >
        <span class="service-card__image" [style.background-image]="'url(' + service.image + ')'"></span>
        <span class="service-card__panel">
          <span class="service-card__text">
            <span class="service-card__label">{{ service.labelKey | translate }}</span>
            <p class="service-card__description">{{ service.descriptionKey | translate }}</p>
          </span>
          <span class="service-card__apply">{{ "Apply" | translate }}</span>
        </span>
      </button>
    </div>

    <div class="ssp-calculator">
      <span class="ssp-calculator__icon-chip">
        <span nz-icon nzType="calculator" class="ssp-calculator__icon"></span>
      </span>
      <div class="ssp-calculator__text">
        <p class="ssp-calculator__title">{{ "Pay your service fees online" | translate }}</p>
        <p class="ssp-calculator__subtitle">
          {{
            "Calculate fees for registration, post-registration, and other services, and pay them online using the SSP Calculator"
              | translate
          }}
        </p>
      </div>
      <a
        class="ssp-calculator__button"
        [href]="sspCalculatorUrl"
        target="_blank"
        rel="noopener"
      >
        {{ "Calculate Fee" | translate }}
      </a>
    </div>

    <div class="services__territory">
      <button
        type="button"
        class="services__territory-toggle"
        [attr.aria-expanded]="isTerritoryOpen"
        (click)="toggleTerritory()"
      >
        {{ "AIFC Territory Office Requirements" | translate }}
        <span
          nz-icon
          nzType="down"
          class="services__territory-chevron"
          [class.services__territory-chevron--open]="isTerritoryOpen"
        ></span>
      </button>
      <div class="services__territory-panel" *ngIf="isTerritoryOpen">
        <p
          class="services__territory-text"
          [innerHTML]="'AIFC Territory Office Requirements: intro' | translate"
        ></p>

        <p class="services__territory-text">
          {{
            "The list below provides suggested business centres within the AIFC territory. Companies may also choose other suitable premises within the AIFC."
              | translate
          }}
        </p>

        <div class="services__territory-offices">
          <div class="services__territory-office" *ngFor="let office of territoryOffices">
            <p class="services__territory-office-name">{{ office.name }}</p>
            <p class="services__territory-office-address">{{ office.address }}</p>

            <a
              *ngIf="office.website as website"
              class="services__territory-office-contact"
              [href]="'https://' + website"
              target="_blank"
              rel="noopener"
            >
              <span nz-icon nzType="global"></span>{{ website }}
            </a>
            <a
              *ngIf="office.phone as phone"
              class="services__territory-office-contact"
              [href]="'tel:' + phone"
            >
              <span nz-icon nzType="phone"></span>{{ phone }}
            </a>
            <a
              *ngIf="office.email as email"
              class="services__territory-office-contact"
              [href]="'mailto:' + email"
            >
              <span nz-icon nzType="mail"></span>{{ email }}
            </a>
          </div>
        </div>

        <p
          class="services__territory-text services__territory-outro"
          [innerHTML]="
            'AIFC Territory Office Requirements: outro' | translate: { propertyGalleryUrl: propertyGalleryUrl }
          "
        ></p>
      </div>
    </div>
  </div>
</section>
